import React from 'react'
import './Experiences.css'
import { useTranslation } from 'react-i18next'

const Experiences = () => {
  const { t } = useTranslation();
  
  return (
    <section id='experiences' className="content_section">
      <div className="content_section_inner">
        <h2>{t('experiences.title')}</h2>
        <div className='container'>
          <div className='col col-1-2'>
            <div className='experience-items-wrapper'>
              <div className='experience-items-line'></div>
              <div className='experience-items-inner-wrapper'>
                <div className="experience-item field">
                  <p className="date">{t('experiences.work.jl_gestion.period')}</p>
                  <h4>{t('experiences.work.jl_gestion.title')}</h4>
                  <p>{t('experiences.work.jl_gestion.description')}</p>
                </div>
                <div className="experience-item field">
                  <p className="date">{t('experiences.work.freelance.period')}</p>
                  <h4>{t('experiences.work.freelance.title')}</h4>
                  <p>{t('experiences.work.freelance.description1')}</p>
                  <p>{t('experiences.work.freelance.description2')}</p>
                </div>

              </div>
            </div>
          </div>

          <div className='col col-1-2'>
            <div className='experience-items-wrapper'>
              <div className='experience-items-line'></div>
              <div className='experience-items-inner-wrapper'>
                <div className="experience-item training">
                  <p className="date">{t('experiences.education.web_dev.period')}</p>
                  <h4>{t('experiences.education.web_dev.title')}</h4>
                  <p>{t('experiences.education.web_dev.description')}</p>
                </div>
                <div className="experience-item training">
                  <p className="date">{t('experiences.education.web_design.period')}</p>
                  <h4>{t('experiences.education.web_design.title')}</h4>
                  <p>{t('experiences.education.web_design.description')}</p>
                </div>
                <div className="experience-item training">
                  <p className="date">{t('experiences.education.autodidact.period')}</p>
                  <h4>{t('experiences.education.autodidact.title')}</h4>
                  <p>{t('experiences.education.autodidact.description')}</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
} 

export default Experiences